export const landingPageConstants = {
    products:"Products",
    solutions:"Solutions",
    resources:"Resources",
    pricing:"Pricing",
    company:"Company",
    login:"Login",
    getStarted:"Get Started",
    heroTitlectaColor:"everything",
    manage:"Manage",
    heroTitle:"from one smart dashboard",
    heroDesc:"Say goodbye to juggling apps. Manage contacts, tasks, calls, and credentials all in one seamless, customizable CRM solution.",
    howItWorks:"How it Works",
    trustedBy:"Trusted by",
    partnersTitle:"world largest business company.",
    relationshipSecTitle:"Everything You Need to Build Better Customer Relationship",
    relationshipSecDesc:"Streamline workflows, nurture leads, and close deals faster with our all-in-one CRM solution designed for growing businesses",
    relBoxTitle1:"Centralized Customer Data",
    relBoxDesc1:"Keep all customer information in one place",
    relBoxTitle2:"Sales Automation",
    relBoxDesc2:"Automate repetitive tasks like follow-ups and reminders",
    relBoxTitle3:"Pipeline Management",
    relBoxDesc3:"Visualize and optimize every stage of the sales process",
    relBoxTitle4:"Customizable Dashboards",
    relBoxDesc4:"Tailor reports and views to your team’s needs",
    featureSecTitle1:"Struggling to Manage Your",
    featureSecTitle2:"Leads and Customers?",
    featureSecDesc:"Our CRM helps you eliminate manual tasks, reduce lead leakage, and deliver exceptional customer experiences",
    featureOneTitle:"Absurdly simple to setup",
    featureOneDesc:"Get started in minutes with an intuitive interface and seamless setup no headaches.",
    featureTwoTitle:"Built for team-selling",
    featureTwoDesc:"Empower collaboration with tools that align your team to close deals faster, together.",
    featureThreeTitle:"Suprisingly proactive",
    featureThreeDesc:"Stay ahead with AI-powered insights that anticipate needs and recommend next steps.",
    toolsSecTitle1:"Works with Tools You",
    toolsSecTitle2:"Already Use",
    toolsSecDesc:"Connect your CRM seamlessly with your favorite apps",
    viewAllIntegrations:"View All Integrations",
    customersSubtitle:"Our Customers",
    customerTitle1:"See Why Teams Love",
    customerTitle2:"Our CRM",
    customerSecDesc:"Connect your CRM seamlessly with your favorite apps",
    customerReview1:"“We’ve improved sales velocity, access to actionable insights, and saved 20% by switching to Contraa’s unified CRM and marketing platform.”",
    customer1Name:"Brooklyn Simmons",
    customer1Desc:"Vice President, Hurs Review",
    customerReview2:"“Contree is the best tool I’ve ever found! From email tracking to workflow automations and game-changing integrations, Contree has plenty of features that help us go beyond our sales targets.”",
    customer2Name:"Robert Fox",
    customer2Desc:"Regional Sales Manager, Airtable",
    talkToSales:"Talk to Sales",
    pricingTitle:"Choose your perfect plan",
    pricingDesc:"Designed for every stage of your journey. Start today, no credit card required.",
    monthly:"Monthly",
    annually:"Annually",
    callActionTitle1:"Ready to Revolutionize Your",
    callActionTitle2:"Customer Relationships?",
    callActionDesc:"Streamline workflows, nurture leads, and close deals faster with our all-in-one CRM solution designed for growing businesses",
    usefullLinks:"Usefull Links",
    Home:"Home",
    customerSuccess:"Customer Success",
    templates:"Templates",
    TrustSecurity:"Trust & Security",
    stayConnected:"Stay Connected",
    Manage360:"Manage360",
    feature:"Features",
    plans:"Plans",
    faq:"FAQ",
    contact:"Contact",
    watchDemo:"Watch Demo",
    whyChooseUs:"Why choose us",
    whyChooseUsDesc:"Empower your team with tools that simplify collaboration, automate workflows, and secure every interaction all from a single smart platform.",
    featureSectionTitle:"Powerful CRM to grow",
    yourBusiness:"your business",
    featureSectionDesc:"Manage360 helps you track leads, automate tasks, and scale your team all in one smart CRM.",
    passwordTitle:"Enterprise-grade password management",
    passwordDesc:"Protect your credentials and collaborate securely with a password vault built for modern teams.",
    videoTitle:"See it in action",
    videoDesc:"Watch how easily you can manage your clients and data securely.",
    ourCustomers:"Our customers",
    customersDesc:"What our users say",
    seeMoreTestimonials:"See More Testimonial",
    similarQuestion:"Similar question",
    faqTitle:"Frequently asked questions",
    faqDesc:"Got questions? We’ve covered everything from features to security to help you get started with confidence.",
    newslatterTitle:"Managing smarter free for 14 days",
    newslatterDesc:"No credit card required. Cancel anytime.",
    requestDemo:"Request Demo",
    manageDesc:" Manage360 is an all-in-one CRM and password manager that streamlines communication, automates tasks, and keeps your team secure.",
    whyUs:"Why choose us",
    privacyPolicy:"Privacy Policy",
    copyright:"Copyright 2025 | All Rights Reserved By",
    companyName:"Benthon Labs"
}